import React from "react";
import HeaderComponent from "components/card/HeaderComponent";
import SelectOption from "components/select/SelectOption";
import { Divider } from "antd";
import {
  Users,
  DollarSign,
  Clock,
  TrendingUp,
  GraduationCap,
  Award,
  CircleCheck,
  Plus,
} from "lucide-react";

const iconMap = {
  users: Users,
  "dollar-sign": DollarSign,
  clock: Clock,
  "trending-up": TrendingUp,
  "graduation-cap": GraduationCap,
  award: Award,
};

export default function ReportTemplate({
  analyticsCards,
  onSelectCard,
  setActiveTab,
}) {
  return (
    <div className="col-span-2">
        <div className="grid grid-cols-3 gap-4 max-h-[600px] overflow-y-auto pr-2 py-2">
          {analyticsCards.map((card) => {
            const Icon = iconMap[card.icon];
            return (
              <div className="border-2 overflow-hidden rounded-xl hover:border-red-300 hover:shadow-md">
                <div
                  className={`p-4 flex flex-col gap-2 rounded-b-none report card-select 
                              cursor-pointer transition-all duration-300 

                              ${      
                                `bg-gradient-to-br ${card.title
                                .toLowerCase()
                                .replace(/\s+/g, "-")}`
                              }`}
                >
                  <div className="flex items-start gap-3">
                    <div
                      className={`p-2.5 shadow-md !rounded-2xl icon-style ${card.title
                        .toLowerCase()
                        .replace(/\s+/g, "-")}`}
                    >
                      {Icon && <Icon className="w-5 h-5 text-white" />}
                    </div>

                    <div className="flex-1 space-y-1">
                      <h4 className="text-base">
                        {card.title}
                      </h4>
                      <span className="status-indicator normal text-[9px] py-0">
                        {card.category}
                      </span>

                    </div>
                  </div>
                </div>
                
                <div className="p-4 pt-6">
                  <p className="text-xs">{card.description}</p>
                  <p className="my-2 text-[11px] font-semibold">Key Metrics:</p>

                  <div className="flex-1 flex-wrap gap-1">
                    {card.tags.map((tag, i) => (
                      <span
                        key={i}
                        className="flex items-center gap-2 text-xs"
                      >
                        <CircleCheck className="w-3 h-3 text-green-600" />
                        {tag}
                      </span>
                    ))}

                  </div>
                  <button 
                    className="inline-flex items-center justify-center rounded-xl text-sm font-medium transition-all h-9 px-4 py-2 w-full mt-3
                              bg-gradient-to-r from-red-600 to-orange-600 hover:from-red-700 hover:to-orange-700 text-white gap-2 font-semibold"
                    type="button"
                    onClick={() => {
                      onSelectCard(card.title);
                      setActiveTab("generate");
                    }}
                  >
                    <Plus className="w-4 h-4"/>
                    Use Template
                  </button>
                </div>

              </div>
              
            );
          })}
        </div>
    </div>
  );
}
